import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import CancelIcon from '@material-ui/icons/Cancel'

export default function PublishDialog (props) {
  const {
    open,
    onClose,
    onPublish
  } = props

  const [showDialog, setShowDialog] = React.useState(false)

  React.useEffect(() => {
  }, [])

  React.useEffect(() => {
    setShowDialog(open)
  }, [open])

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    onClose(event, reason)
  }

  return (
    <Dialog maxWidth="xs" fullWidth={true} open={showDialog} onClose={handleClose}>
      <DialogTitle>Publish Hotkeys</DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12}>
            <Typography>Click Publish to push all hotkey menu changes to tills. Editing will be temporarily locked during this process.</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={onPublish} color="primary">
          <CloudUploadIcon />&nbsp;&nbsp;Publish
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

PublishDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onPublish: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
